import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs/internal/BehaviorSubject';

@Injectable()
export class NavbarRerenderService {
  private messageSource = new BehaviorSubject('false');
  currentMessage = this.messageSource.asObservable();
  private newMessage = new BehaviorSubject('false')
  newCurrentMessage = this.newMessage.asObservable();


  isHome:boolean = false
  public mobileNavToggle =  new BehaviorSubject<boolean>(true);

  constructor() { }

  setIsHome(isHome) {
    this.isHome = isHome;
  }

  getIsHome(){
    return this.isHome;
  }
  
  newNavMessage(message) {
    // console.log('got in the service:',message)
    this.newMessage.next(message);
  }

  changeMessage(message) {
    this.messageSource.next(message);
  }
}
